/** Practical shortlist of IANA zones for case meta. Free text still allowed via Combobox input. */
export const TIMEZONE_OPTIONS = [
  "America/Los_Angeles",
  "America/Denver",
  "America/Chicago",
  "America/New_York",
  "America/Sao_Paulo",
  "Europe/London",
  "Europe/Paris",
  "Europe/Berlin",
  "Asia/Tokyo",
  "Asia/Shanghai",
  "Asia/Hong_Kong",
  "Asia/Singapore",
  "Asia/Seoul",
  "Australia/Sydney",
  "Pacific/Auckland",
  "UTC",
] as const;

export function timezoneItems(current: string): string[] {
  const trimmed = current.trim();
  if (trimmed && !(TIMEZONE_OPTIONS as readonly string[]).includes(trimmed)) {
    return [trimmed, ...TIMEZONE_OPTIONS];
  }
  return [...TIMEZONE_OPTIONS];
}
